import { inject, Injectable } from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { withHistory } from '@sama/rxjs-core';
import { filter } from 'lodash';
import { merge } from 'rxjs';
import { filter as filterOperator, map } from 'rxjs/operators';
import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { AbstractAnnotationTransientInfoUpdateService } from './abstract-annotation-transient-info-update.service';
import { AnnotationColorService } from './annotation-color.service';

@Injectable()
export class AnnotationColorUpdateService extends AbstractAnnotationTransientInfoUpdateService<'color'> {
  protected override transientKey = 'color' as const;

  private annotationColorService = inject(AnnotationColorService);

  subscribeToChangesUpdatingColor() {
    this.subscribeToChangesUpdatingTransientValue();
  }

  protected override getObjectIdsChanged$() {
    return merge(this.getObjectIdsWithClassChanged$()).pipe(
      filterOperator((objectIds) => objectIds.length > 0),
    );
  }

  protected override getNewTransientValueForObject(object: ObjectState) {
    return this.annotationColorService.getObjectColor(object);
  }

  protected override getNewTransientValueForShape(shape: ShapeState) {
    return this.annotationColorService.getShapeColor(shape);
  }

  private getObjectIdsWithClassChanged$() {
    return this.taskWorkspaceStore('objects').$.pipe(
      withHistory(1),
      map(([currentObjects, previousObjects]) => {
        const objectsWithClassChanged = filter(
          currentObjects,
          (currentObject, objectId) => {
            assert(isDefined(currentObject), 'object states must be defined');
            const previousClass =
              previousObjects && previousObjects[+objectId]?.class;
            return previousClass !== currentObject.class;
          },
        );

        return objectsWithClassChanged
          .filter(isDefined)
          .map((object) => object.index);
      }),
    );
  }
}
